import { render } from "./DynamicCard.vue?vue&type=template&id=370135c7&ts=true"
import script from "./DynamicCard.vue?vue&type=script&lang=ts"
export * from "./DynamicCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "370135c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('370135c7', __exports__)) {
    api.reload('370135c7', __exports__)
  }
  
  module.hot.accept("./DynamicCard.vue?vue&type=template&id=370135c7&ts=true", () => {
    api.rerender('370135c7', render)
  })

}


export default __exports__